import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-createaccessmanagementone',
  templateUrl: './createaccessmanagementone.component.html',
  styleUrls: ['./createaccessmanagementone.component.css']
})
export class CreateaccessmanagementoneComponent implements OnInit {
  returnUrl= "/dashboard/accessmanagement";
  constructor(private router:Router) { }

  ngOnInit(): void {
    
  }
  accessmanagement(){
    this.router.navigate([this.returnUrl]);
  }
}
